const MS_PER_DAY = 1000 * 60 * 60 * 24;

const toDateMs = (value) => {
  if (!value) return null;

  const ms = new Date(String(value).length === 10 ? `${value}T00:00:00` : value).getTime();

  return Number.isNaN(ms) ? null : ms;
};

export const getDaysInEvidence = ({
  receivedDate,
  submittedAt,
  dateTimeCollected,
  isDisposed,
  dispositionDate,
} = {}) => {
  const startMs = toDateMs(receivedDate || submittedAt || dateTimeCollected);

  if (startMs === null) return null;

  const endMs = isDisposed ? toDateMs(dispositionDate) ?? Date.now() : Date.now();

  return Math.floor((endMs - startMs) / MS_PER_DAY);
};

export default getDaysInEvidence;
